// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field, clearSubmitErrors } from 'redux-form';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { KEY_CODES } from '@tcp/core/src/constants/keyboard.constants';
import TextBox from '@tcp/core/src/components/common/atoms/TextBox';
import Button from '@tcp/core/src/components/common/atoms/Button';
import { getIconPath } from '@tcp/core/src/utils/utils';
import Image from '@tcp/core/src/components/common/atoms/Image';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Heading from '@tcp/core/src/components/common/atoms/Heading';
import { routerPush } from '@tcp/core/src/utils';
import { CUSTOMER_HELP_DIRECT_ROUTES } from '@tcp/core/src/components/features/account/CustomerHelp/CustomerHelp.constants';
import { keyboard } from '../../../../../../../../../web/src/constants/constants';
import style from '../styles/CouponForm.style';
import ErrorMessage from '../../ErrorMessage';
import { couponFieldLength, getFormattedValue } from '../CouponForm.utils';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import CouponLabels, {
  CHECKOUT_LABELS,
} from '../../../organism/CouponAndPromos/views/Coupon.labels';

class CouponForm extends React.PureComponent {
  state = { touched: false, couponCode: '', invalidCoupon: false };

  checkoutErrorLabels = getLabelFromCopyOrFromTranslation(CHECKOUT_LABELS, CouponLabels);

  componentDidMount() {
    const { setAppliedCOuponStatusAction } = this.props;
    setAppliedCOuponStatusAction(false);
  }

  componentDidUpdate() {
    const { appliesCouponSuccess, setAppliedCOuponStatusAction } = this.props;
    if (appliesCouponSuccess === true) {
      setTimeout(() => {
        setAppliedCOuponStatusAction(false);
      }, 2000);
    }
  }

  renderTextBox = ({ input, ...otherParams }) => {
    const { appliesCouponSuccess } = this.props;

    const { couponCode } = this.state;
    // eslint-disable-next-line no-nested-ternary
    const formattedValue = input.value
      ? getFormattedValue(input.value)
      : appliesCouponSuccess
      ? couponCode
      : '';
    this.setState({
      couponCode: formattedValue,
    });

    // eslint-disable-next-line
    input = { ...input, value: formattedValue };
    return (
      <TextBox
        input={input}
        couponSectionNewDesign
        appliesCouponSuccess={appliesCouponSuccess}
        {...otherParams}
        fromCouponForm={true}
      />
    );
  };

  toggleTouched = () => {
    const { touched } = this.state;
    const { dispatch } = this.props;
    this.setState({ touched: !touched });
    dispatch(clearSubmitErrors('CouponForm'));
  };

  handleKeyDown = (event, callback) => {
    const { KEY_ENTER, KEY_SPACE } = keyboard;
    const { which } = event;
    if (which === KEY_ENTER || which === KEY_SPACE) {
      callback({ status: 'open' });
    }
  };

  handleSubmit = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const { handleSubmit, multiUseCouponList, fromIsApplyAction } = this.props;
    const { couponCode } = this.state;
    const couponLength = couponCode ? couponCode.length : 0;
    const validCouponPattern = /^Y\d{3}0[3|5][A-Za-z0-9]{8}$/;
    const isCouponFormatMatched = validCouponPattern.test(couponCode);
    const couponList = multiUseCouponList?.split('|');
    const couponFound = couponList?.find((couponItem) => couponItem === couponCode);
    setTimeout(() => {
      if (!couponFound && (couponLength < 14 || couponLength > 14 || !isCouponFormatMatched)) {
        this.mergeCouponError();
        this.setState({
          invalidCoupon: true,
        });
        return false;
      }
      const { touched } = this.state;

      if (touched) {
        this.toggleTouched();
      }
      fromIsApplyAction(true);

      return handleSubmit(e);
    }, 0);
  };

  mergeCouponError = () => {
    const { showCouponMergeError } = this.props;
    const { invalidCoupon } = this.state;
    if (invalidCoupon) {
      return (
        <ErrorMessage
          fontSize="fs12"
          fontWeight="extrabold"
          className="coupon_error_message"
          error={renderLabel(
            this.checkoutErrorLabels?.bagPage?.lbl_coupon_invalid_format_error,
            'lbl_coupon_invalid_format_error'
          )}
        />
      );
    }
    if (showCouponMergeError) {
      return (
        <ErrorMessage
          fontSize="fs12"
          fontWeight="extrabold"
          className="coupon_error_message"
          error={renderLabel(
            this.checkoutErrorLabels?.bagPage?.lbl_coupon_mergecart_error,
            'lbl_coupon_mergecart_error'
          )}
        />
      );
    }
    return null;
  };

  render() {
    const {
      dataLocators,
      fieldName,
      className,
      error,
      isFetching,
      idPrefix,
      pristine,
      submitting,
      newBag,
      spc,
      spcBag,
      appliesCouponSuccess,
      setAppliedCOuponStatusAction,
      multiUseCouponList,
      checkoutLabels,
      isCSHEnabled,
      isLoyaltyTieringEnabled,
    } = this.props;
    const { touched } = this.state;
    const { couponCode } = this.state;
    const couponLength = couponCode ? couponCode.length : 0;
    const validCouponPattern = /^Y\d{3}0[3|5][A-Za-z0-9]{8}$/;
    const isCouponFormatMatched = validCouponPattern.test(couponCode);
    const couponList = multiUseCouponList?.split('|');
    const couponFound = couponList?.find((couponItem) => couponItem === couponCode);
    const couponInvalid =
      !couponFound && (couponLength < 14 || couponLength > 14 || !isCouponFormatMatched);
    return (
      <div className={className}>
        <div className={`coupon_form_container`}>
          <Heading
            fontFamily="primaryFontFamily"
            component="h2"
            variant="h6"
            className="coupon_form_heading"
            color="black"
            dataLocator="Offers-heading"
          >
            {isLoyaltyTieringEnabled
              ? renderLabel(checkoutLabels?.bagPage?.lbl_offers_title, 'lbl_offers_title')
              : renderLabel(
                  checkoutLabels?.bagPage?.lbl_coupon_collapsible_header,
                  'lbl_coupon_collapsible_header'
                )}

            {isCSHEnabled && (
              <BodyCopy
                fontSize="fs12"
                fontFamily="secondary"
                className="coupon_need_help_link"
                component="span"
                fontWeight="semibold"
                tabIndex="0"
                dataLocator="Offers-need-help-link"
                onClick={() =>
                  routerPush(
                    CUSTOMER_HELP_DIRECT_ROUTES.COUPON_ISSUE.to,
                    CUSTOMER_HELP_DIRECT_ROUTES.COUPON_ISSUE.asPath
                  )
                }
                role="button"
                aria-label="offers-need-help-button"
                onKeyDown={(e) => {
                  if (e.keyCode === KEY_CODES.KEY_ENTER) {
                    routerPush(
                      CUSTOMER_HELP_DIRECT_ROUTES.COUPON_ISSUE.to,
                      CUSTOMER_HELP_DIRECT_ROUTES.COUPON_ISSUE.asPath
                    );
                  }
                }}
              >
                {isLoyaltyTieringEnabled ? (
                  <Image alt="profile" className="link-icon" src={getIconPath('info-icon')} />
                ) : (
                  renderLabel(checkoutLabels?.bagPage?.lbl_couponform_help, 'lbl_couponform_help')
                )}
              </BodyCopy>
            )}
          </Heading>
          <form onSubmit={this.handleSubmit} className="coupon_submit_form">
            <Field
              placeholder={renderLabel(
                checkoutLabels?.bagPage?.lbl_couponform_placeholder,
                'lbl_couponform_placeholder'
              )}
              name={fieldName}
              id={`${fieldName}-id-${idPrefix}`}
              type="text"
              onChange={!touched && this.toggleTouched}
              component={this.renderTextBox}
              dataLocator={dataLocators.inputField}
              className="coupon_code_input"
              maxLength={couponFieldLength}
              newBag={newBag}
              spc={spc || spcBag}
              showSuccessCheck={appliesCouponSuccess}
              enableSuccessCheck={!couponInvalid && appliesCouponSuccess}
              spcBag={spcBag}
              onFocus={() => {
                this.setState({ invalidCoupon: false });
                setAppliedCOuponStatusAction(false);
              }}
              textBoxLoader={submitting}
            />
            <Button
              disabled={isFetching || pristine || submitting}
              buttonVariation="fixed-width"
              type="submit"
              data-locator={dataLocators.submitButton}
              className="coupon_submit_button"
              spc={spc}
              spcBag={spcBag}
              newBag={newBag}
              onClick={this.handleSubmit}
            >
              {renderLabel(checkoutLabels?.bagPage?.lbl_couponform_submit, 'lbl_couponform_submit')}
            </Button>
          </form>
        </div>
        {!touched && !spc && (
          <ErrorMessage
            fontSize="fs12"
            fontWeight="extrabold"
            className="coupon_error_message"
            icon="circle-info-red"
            error={error && error.msg}
            isEspot={error && error.isPlaceCashError}
          />
        )}
        {this.mergeCouponError()}
      </div>
    );
  }
}

CouponForm.propTypes = {
  dataLocators: PropTypes.shape({
    submitButton: PropTypes.string,
    inputField: PropTypes.string,
  }),
  handleSubmit: PropTypes.func,
  fieldName: PropTypes.string,
  className: PropTypes.string.isRequired,
  error: PropTypes.string,
  idPrefix: PropTypes.string,
  onNeedHelpTextClick: PropTypes.func,
  isFetching: PropTypes.isRequired,
  coupon: PropTypes.string,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  showCouponMergeError: false,
  newBag: PropTypes.bool,
  spc: PropTypes.bool,
  spcBag: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  isLoyaltyTieringEnabled: PropTypes.bool,
};

CouponForm.defaultProps = {
  dataLocators: {
    submitButton: 'coupon_submit_btn',
    inputField: 'coupon_code',
  },
  error: '',
  fieldName: 'couponCode',
  handleSubmit: () => {},
  onNeedHelpTextClick: () => {},
  idPrefix: '',
  coupon: '',
  showCouponMergeError: false,
  newBag: false,
  spc: false,
  spcBag: false,
  isLoyaltyTieringEnabled: false,
};

export const onSubmitSuccess = (result, dispatch, { reset }) => reset();

export default reduxForm({
  form: 'CouponForm',
  onSubmitSuccess,
})(withStyles(CouponForm, style));

export { CouponForm };
